<template>
    <div id="analysis-one">
        <h2>
            <template v-if="i18nText.title">{{$t(i18nText.title)}}</template>
            <template v-else>{{title}}</template>
        </h2>
        <template v-if="i18nText.describe"><p>{{$t(i18nText.describe)}}</p></template>
        <template v-else><p v-html="describe">{{describe}}</p></template>
        <el-button-group>
            <template v-if="noDisplay.indexOf('smoothLine') === -1">
                <el-button size="small" @click="handleChartChange('smoothLine')"><i class="iconfont ipiconlinechart" aria-hidden="true"></i> 
                <template v-if="i18nText.smoothLine">{{$t(i18nText.smoothLine)}}</template>
                <template v-else>曲线图</template>
            </el-button>
            </template>
            <template v-if="noDisplay.indexOf('bar') === -1">
                <el-button size="small" @click="handleChartChange('bar')"><i class="iconfont ipiconbarchart" aria-hidden="true"></i> 
                    <template v-if="i18nText.bar">{{$t(i18nText.bar)}}</template>
                    <template v-else>柱状图</template>
                </el-button>            
            </template>    
            <template v-if="noDisplay.indexOf('crossBar') === -1">
                <el-button size="small" @click="handleChartChange('crossBar')"><i class="iconfont ipiconcrossBar" aria-hidden="true"></i> 
                    <template v-if="i18nText.crossBar">{{$t(i18nText.crossBar)}}</template>
                    <template v-else>横向柱状图</template>
                </el-button>
            </template>
            <template v-if="noDisplay.indexOf('radar') === -1">
                <el-button size="small" @click="handleChartChange('radar')"><i class="iconfont ipiconradar" aria-hidden="true"></i> 
                <template v-if="i18nText.radar">{{$t(i18nText.radar)}}</template>
                <template v-else>雷达图</template>
                </el-button>
            </template>
            <template v-if="noDisplay.indexOf('pie') === -1">
                <el-button size="small" @click="handleChartChange('pie')"><i class="iconfont ipiconpie" aria-hidden="true"></i> 
                    <template v-if="i18nText.pie">{{$t(i18nText.pie)}}</template>
                    <template v-else>饼图</template>
                </el-button>
            </template>
            <template v-if="noDisplay.indexOf('rectangle') === -1">
                <el-button size="small" @click="handleChartChange('rectangle')"><i class="iconfont ipiconrectangle" aria-hidden="true"></i> 
                    <template v-if="i18nText.rectangle">{{$t(i18nText.rectangle)}}</template>
                    <template v-else>矩形树图</template>
                </el-button>
            </template>
            <el-button size="small" @click="handleShowTable()"><i class="iconfont ipiconform" aria-hidden="true"></i> 
                <template v-if="i18nText.table">{{$t(i18nText.table)}}</template>
                <template v-else>表格</template>
            </el-button>
            <slot name="button"></slot>  
            <el-button class="export" size="small" type="primary" @click="exportDateTable"><i class="iconfont ipiconform" aria-hidden="true"></i> 
                <template v-if="i18nText.exportTable">{{$t(i18nText.exportTable)}}</template>
                <template v-else>导出表格</template>
            </el-button>  
            <el-button class="export" type="primary" size="small" @click="exportImage"><i class="iconfont ipiconpicture"></i> 
                <template v-if="i18nText.exportImg">{{$t(i18nText.exportImg)}}</template>
                <template v-else>导出图片</template>
            </el-button>
        </el-button-group>
        <div v-if="tableData1.length === 0" v-loading="innerLoading || loading" class="empty-chart">
            <template v-if="i18nText.noData">{{$t(i18nText.noData)}}</template>
            <template v-else>暂无数据</template>
        </div>
        <div id="chart" v-show="!isShowTable" v-loading="innerLoading || loading"></div>
        <div v-show="isShowTable" class="table">
            <el-table :data="tableData1"  style="width: 100%" height="520" id="export-table">
                <el-table-column
                    prop="key"
                    :label="tableTitle[0]" align="center">
                    <template slot-scope="scope">
                        <span v-html="scope.row.key">{{scope.row.key}}</span>
                    </template>    
                </el-table-column>
                <el-table-column
                    prop="value"
                    :label="tableTitle[1]">
                    <template slot-scope="scope">
                        <a class="link" v-if="scope.row.value > 0" @click="handleClickItem(scope.row,tableTitle[1])">{{scope.row.value}}</a>
                        <span v-else>{{scope.row.value}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="tableTitle[2]"
                    prop="value2"
                    :label="tableTitle[2]">
                    <template slot-scope="scope">
                        <a class="link" v-if="scope.row.value2 > 0" @click="handleClickItem(scope.row,tableTitle[2])">{{scope.row.value2}}</a>
                        <span v-else>{{scope.row.value2}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import View from '@antv/data-set'
export default {
  name: 'ipAnalysisOneDimension',
  props:{
        title:{type: String,default: ''},
        describe:{type:String,default:''},
        defaultChart:{
            type:String,
            default:'smoothLine',
            validator(value){
                if(value === 'smoothLine' || value === 'bar' || value === 'radar' 
                || value === 'pie' || value === 'crossBar' || value === 'rectangle'){
                    return true
                }else{
                    return false
            }
        }},
        chartData:{
            type:Array,
            default(){
                return []
            },
            required:true
        },
        tableTitle:{
            type:Array,
            default(){ 
                return ['名称','数量']
                } 
        },
        xIsRotate:{type:Boolean,default:false},
        noDisplay:{type:Array,default(){
            return []
        }},
        loading:{type:Boolean,default:false},
        color:{type:String,default:''},
        tableData:{type:Array,default(){
            return []
        }},
        alias:{type:Object,default(){
            return {x:'key',y:'value'}
        }},
        i18nText:{type:Object,default(){
            return {}
        }}
  },
  data(){
      return{
        innerLoading:true,
        chart:{},
        isShowTable:false,
        tableData1:[],
      }
  },
  watch: {
        chartData(nv) {
            if(this.tableData.length === 0){
                this.tableData1 = nv;
            }
            this.handleChartChange(this.defaultChart); 
        },
        tableData(nv){
            this.tableData1 = nv;
        }
  },
  mounted(){
       const theme = G2.Util.deepMix({
                shape: {
                    interval: {
                        fillOpacity: 1 // 填充透明度设置
                    },
                    intervalStack:{
                        fillOpacity: 1 // 填充透明度设置
                    },
                    line:{
                        fillOpacity: 1 // 填充透明度设置
                    },
                    polygon:{
                        fillOpacity: 1 // 填充透明度设置
                    }
                },
                axis: {
                    top:{
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    },
                    bottom: {
                        label: {
                            textStyle:{
                                rotate: this.xIsRotate ? -Math.PI / 6 : 0,
                                fill: '#000',
                                textAlign: this.xIsRotate ? 'end' : 'center',
                                textBaseline: 'middle',
                            }
                        },
                        title:{
                            textStyle: {
                                fill: '#000', // 文本的颜色
                            },
                            position:'end'
                        }
                    },
                    left: {
                        label: {
                            autoRotate:false,
                            textStyle: {
                                fill: '#000',
                                rotate:0
                            } // 左部标签文本的颜色
                        },
                        title:{
                            textStyle: {
                                fill: '#000', // 文本的颜色
                            },
                            position:'center'
                        }
                    },
                    right: {
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    },
                    radius:{
                        label:{
                            textStyle: { fill: '#000'} 
                        }
                    },
                    circle:{
                        label: {
                            textStyle: { fill: '#000'} // 右部标签文本的颜色
                        }
                    }
                },
            label: {
                textStyle: {
                        fill: '#000',
                }
            },
            legend:{
                bottom: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                },
                left: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                },
                right: {
                    textStyle: {
                        fill: '#000',// 底部标签文本的颜色
                    }
                }
            },
            tooltip: {
                'g2-tooltip':{
                    color: 'rgb(0, 0, 0)',
                }
            }
        }, G2.Theme);
        G2.Global.setTheme(theme);
        this.chart = new G2.Chart({
                container: 'chart',
                forceFit: true,
                height: 520,
                padding:['auto',20,'auto','auto']
            });
      
        this.handleChartChange(this.defaultChart); 
  },
  methods:{
        handleChartChange(type){
            this.isShowTable = false;
            switch (type) {
                case 'smoothLine':
                    this.smoothLineChart();
                    break;
                case 'bar':
                    this.barChart();
                    break;
                case 'crossBar':
                    this.crossBarChart();
                    break;
                case 'radar':
                    this.radarChart();
                    break;
                case 'pie':
                    this.pieChart()
                    break;
                case 'rectangle':
                    this.rectangleChart();
                    break;
            }
        },
        handleShowTable(){
            this.isShowTable = true;
        },
        exportDateTable () {
            this.$emit('export-table','export-table');
        },
        exportImage(){
            let self = this;
            setTimeout(function() {
                self.chart.downloadImage(self.title);
            }, 1500);
        },
        handleClickItem(row,col){
            this.$emit('table-click',row,col);
        },
        // 饼图
        pieChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('polar');

            var ds = new View();
            var dv = ds.createView().source(this.chartData);

            // 通过 DataSet 计算百分比
            dv.transform({
                type: 'percent',
                field: 'value',
                dimension: 'key',
                as: 'percent'
            });

            this.chart.source(dv, {
                percent: {
                    formatter: function formatter(val) {
                        val = (val * 100).toFixed(2) + '%';
                        return val;
                    }
                }
            });
            this.chart.coord('theta', {
                radius: 0.8
            });
            this.chart.tooltip({
                showTitle: false,
                itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>'
            });
            this.chart.intervalStack().position('value').color('key').label('key*value')
            .tooltip('key*value*percent', function(item, value, percent) {
                percent = (percent * 100).toFixed(2) + '%';
                return {
                    name: item,
                    value: value + ' (' + percent + ')'
                };
            }).style({
                lineWidth: 1,
                stroke: '#fff'
            });
            this.chart.render();
            this.innerLoading = false;
        },
        // 雷达图
        radarChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('polar');
            this.chart.coord('polar', {
                radius: 0.8
            });

            if (this.color) {
                this.chart.line().position('key*value').color(this.color).size(2);
                this.chart.point().position('key*value').color(this.color).shape('circle').size(4).style({
                    stroke: '#fff',
                    lineWidth: 1,
                    fillOpacity: 1
                });
                this.chart.area().position('key*value').color(this.color);
            } else{
                this.chart.line().position('key*value').size(2);
                this.chart.point().position('key*value').shape('circle').size(4).style({
                    stroke: '#fff',
                    lineWidth: 1,
                    fillOpacity: 1
                });
                this.chart.area().position('key*value');
            }
          
            this.chart.render();
            this.innerLoading = false;
        },
        // 曲线图
        smoothLineChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.chartData);
            this.chart.scale('value', {
                min: 0,
                alias: this.alias['y']
            });
            this.chart.scale('key', {
                range: [0.02, 1],
                alias: this.alias['x']
            });
            this.chart.tooltip({
                crosshairs: {
                type: 'line'
                }
            });
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate: this.xIsRotate ?-Math.PI/6 :0,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                }
            });
            if(this.color){
                this.chart.line().position('key*value').color(this.color).shape('smooth');
                this.chart.point().position('key*value').color(this.color).size(4).shape('circle').style({
                    stroke: '#fff',
                    lineWidth: 1
                });
            }else{
                this.chart.line().position('key*value').shape('smooth');
                this.chart.point().position('key*value').size(4).shape('circle').style({
                    stroke: '#fff',
                    lineWidth: 1
                });
            }
            this.chart.render();
            this.innerLoading = false;
        },
        // 柱状图
        barChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.chartData);
            this.chart.scale({
                value:{
                    alias: this.alias['y']
                },
                key:{
                    alias: this.alias['x']
                }
            });
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate: this.xIsRotate ?-Math.PI/6 :0,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                }
            });
            if (this.color){//分组柱状图
                this.chart.interval().position('key*value').color(this.color).adjust([{
                    type: 'dodge',
                    marginRatio: 1 / 32
                }]);
            } else{
                this.chart.interval().position('key*value');
            }
            this.chart.render();
            this.innerLoading = false;
        },
        crossBarChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('rect');
            this.chart.source(this.chartData);
            this.chart.scale({
                value:{
                    alias: this.alias['y'],
                },
                key:{
                    alias: this.alias['x'],
                }
            });
            if (this.color){//分组柱状图
                this.chart.interval().position('key*value').color(this.color).adjust([{
                    type: 'dodge',
                    marginRatio: 1 / 32
                }]);
            } else {
                this.chart.interval().position('key*value');
            }
            this.chart.coord().transpose();
            this.chart.axis('key',{
                label:{
                    autoRotate:false,
                    textStyle:{
                        rotate:0,
                        textAlign: 'end',
                        textBaseline: 'middle',
                    }
                },
                title:false
            })
            this.chart.render();
            this.innerLoading = false;
        },
        rectangleChart(){
            if (!this.chartData.length < 0){
                this.innerLoading = false;
                return
            }
            this.chart.clear().source(this.chartData).coord('rect');
            var root = {
                key:'root',
                children:this.chartData
            };
            var ds = new View();
            var dv = ds.createView();
            dv.source(root, {
                type: 'hierarchy'
            }).transform({
                field: 'value',
                type: 'hierarchy.treemap',
                tile: 'treemapResquarify',
                as: ['x', 'y']
            });
            var nodes = dv.getAllNodes();
            nodes.map(function(node) {
                node.key = node.data.key;
                node.value = node.data.value;
                return node;
            });
            this.chart.clear().source(nodes);
            this.chart.coord('rect');
            this.chart.scale({
                value: {
                    nice: false
                }
            });
            this.chart.animate(false);
            this.chart.axis(false);
            this.chart.legend(false);
            this.chart.tooltip({
                showTitle: false,
                itemTpl: '<li data-index={index}>' + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>' + '{key}<br/>' + '<span style="padding-left: 16px">专利数：{count}</span><br/>' + '</li>'
            });
            this.chart.polygon().position('x*y').color('key').tooltip('key*value', function(key, count) {
                return {
                    key: key,
                    count: count
                };
            }).style({
                lineWidth: 1,
                stroke: '#fff'
            }).label('key', {
                offset: 0,
                textStyle: {
                    fontSize: '12',
                    textBaseline: 'middle',
                    fill:'#fff'
                },
                formatter: function formatter(val) {
                    if (val !== 'root') {
                        return val;
                    }
                }
            });
            this.chart.render();
            this.innerLoading = false;
        }
  }
}
</script>

<style lang="scss" scoped>
#analysis-one{
    position: relative;
    color: #333;
    .empty-chart{
        width: 100%;
        height: 500px;
        position: absolute;
        z-index: 900;
        background: #ffffff;
        font-size: $sm-font-size;
        color: #4d4d4d;
        text-align: center;
        padding-top: 35px;
    }
    h2{
        font-size: $lg-font-size;
        margin-bottom:10px;
        font-weight: normal;
    }
    p{
        margin: 10px 0 15px 0;
        line-height: 20px;
        font-size: $sm-font-size;
    }
    .export{
        margin-left: 20px;
    }
    #chart{
        margin-top: 20px;
        height: 520px;
    }
    .link{
        color: $theme-color;
        cursor: pointer;
    }
    .table{
        margin-top: 20px;
    }
}
</style>
<style lang="scss">
#analysis-one{
    .el-table{
        color: #333;
        th{
            background:#EFF2F6;
            color: #333;
            font-weight: normal;
            // font-size: $md-font-size;
            padding: 6px 0;
        }
    }
}
</style>

